import Vue from "vue";
import axios from "axios";
import "../../../../filters";
import moment from "moment";
import users from "../../../../users";
import { validationMixin } from "vuelidate";
import { gmapApi } from "vue2-google-maps";
import { getOfflinePagingOptions } from "@/utils";

export default {
  name: "SelectMeterActivity",
  mixins: [users, validationMixin],
  components: {
    EmptyState: require("@/customcontrols/emptyState/emptyState.vue").default,
    DataGridComp: require("../../../../customcontrols/datagrid.vue").default,
    filterDataComp: require("../../../../customcontrols/filterData.vue")
      .default,
  },
  props: {
    dataObj: {
      type: Object,
      required: true,
    },
    isOffline: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      defaultWarehouseId: "",
      appData: {},
      options: { pageSize: 10, total: 0, page: 1 },
      totalRow: 0,
      meters: [],
      metersCols: [],
      customInstallationDateView: null,
      installationDateView: null,
      noDataFound: false,

      keyColumn: "id",
      showSelectedMeter: false,

      showSelectedPanel: false,
      filterObj: [],
      isNewMeter: false,
      showMapDialog: false,
      meterLocation: {},
      disabledDates: (date) => {
        let day = moment(date);
        let today = moment();
        return day > today;
      },
      selectedMeter: {},
      preference: {},
      selectedWarehouse: {},
      showMapButton: false,
    };
  },
  created() {
    this.fillMetersCols();
    this.init();
  },
  async mounted() {
    let mapKey = this.$store.state.settings.googleMapsAPIKey;
    this.showMapButton = mapKey != null && mapKey.length > 0 ? true : false;
    if (!this.dataObj.meterModel.gpsX && !this.dataObj.meterModel.gpsY)
      await this.getGeoLocation();
  },
  computed: {
    meterModelType: function () {
      return this.dataObj.meterModel.type;
    },
    google: gmapApi,
    offlineLookups: function () {
      if (!this.isOffline) return;
      try {
        return (
          this.$store.state.offlineApplicationsData.activityLookups[
            this.dataObj.currActivity
          ] ?? null
        );
      } catch (err) {
        return null;
      }
    },
    offlineMetersLength: function () {
      if (this.isOffline && this.offlineLookups) {
        return this.offlineLookups.meters.length ?? 0;
      } else return null;
    },
  },
  watch: {
    installationDateView: function (val) {
      if (val == null) this.dataObj.meterModel.installationDate = "";
      else this.dataObj.meterModel.installationDate = moment(val).format();
    },
    customInstallationDateView: function (val) {
      if (val == null) this.dataObj.customMeterModel.installationDate = "";
      else
        this.dataObj.customMeterModel.installationDate = moment(val).format();
    },
    isNewMeter: function (val) {
      this.dataObj.meterModel.isNewMeter = val;
      this.dataObj.customMeterModel.isNewMeter = val;
    },
    "dataObj.customMeterModel.reference": function (val) {
      if (this.dataObj.duplicateSerialNo == true) {
        this.dataObj.customMeterModel.serial = val;
      }

      if (this.dataObj.duplicateTagNo == true) {
        this.dataObj.customMeterModel.tagNumber = val;
      }
    },
  },
  methods: {
    isWareHouseRequired() {
      return this.dataObj.meterModel.isMandatorySourceWarehouse
        ? "input select-menu mandatory--field"
        : "input select-menu";
    },
    init() {
      Vue.nextTick(() => {
        if (
          this.dataObj.meterModel &&
          this.dataObj.meterModel.installationDate &&
          moment(this.dataObj.meterModel.installationDate).isAfter(moment())
        ) {
          this.dataObj.meterModel.installationDate = moment().format();
        }

        this.fillCustomMeter();

        this.isNewMeter = this.dataObj.enterMeterEnabled;
        this.dataObj.meterModel.isNewMeter = this.isNewMeter;
        this.dataObj.customMeterModel.isNewMeter = this.isNewMeter;

        this.appId = this.dataObj.appId;
        this.fillFiltersObj();
        let today = moment().format();
        if (!this.dataObj.meterModel.installationDate)
          this.dataObj.meterModel.installationDate = today;

        this.installationDateView = new Date(
          moment(this.dataObj.meterModel.installationDate).format()
        );

        if (!this.dataObj.customMeterModel.installationDate)
          this.dataObj.customMeterModel.installationDate = today;
        this.customInstallationDateView = new Date(
          moment(this.dataObj.customMeterModel.installationDate).format()
        );
        this.dataObj.customMeterModel.installationDate = "";

        this.$material.locale.dateFormat = "dd/MM/yyyy";

        this.getSelectedWarehouse();

        if (this.dataObj.duplicateSerialNo == true)
          this.dataObj.customMeterModel.serial =
            this.dataObj.customMeterModel.reference;

        if (this.dataObj.duplicateTagNo == true)
          this.dataObj.customMeterModel.tagNumber =
            this.dataObj.customMeterModel.reference;
      });
    },
    getSelectedWarehouse() {
      this.preference = JSON.parse(this.$localStorage.get("_preference"));
      this.selectWarehouse(this.dataObj.warehouse);
    },
    selectWarehouse(wareHouse, meterType = "customMeterModel") {
      let selWare;
      if (
        wareHouse != null &&
        wareHouse != "" &&
        wareHouse > 0 &&
        Array.isArray(this.dataObj.warehouses) &&
        this.dataObj.warehouses.length
      ) {
        selWare = this.dataObj.warehouses.filter((p) => p.value == wareHouse);
      }

      if (
        (selWare == null || selWare.length == 0) &&
        Array.isArray(this.dataObj.warehouses) &&
        this.dataObj.warehouses.length
      ) {
        selWare = this.dataObj.warehouses.filter(
          (p) => p.value == this.preference.meterWarehouseId
        );
      }

      if (selWare != null && selWare.length > 0) {
        this.selectedWarehouse = selWare[0];
        this.dataObj[meterType].warehouse = this.selectedWarehouse.value;
      }
    },
    fillCustomMeter() {
      let temp = {
        duplicateSerialNo: "",
        duplicateTagNo: "",
        id: "",
        meterDisplay: "",
        type: "",
        typeDisplay: "",
        reference: "",
        serial: "",
        tagNumber: "",
        installationDate: "",
        make: "",
        makeDisplay: "",
        size: "",
        sizeDisplay: "",
        condition: "",
        conditionDisplay: "",
        warehouse: "",
        warehouseDisplay: "",
        factor: "",
        dials: "",
        gpsX: "",
        gpsY: "",
        gpsAccuracy: "",
        comment: "",
        isMandatorySourceWarehouse:
          this.dataObj.meterModel.isMandatorySourceWarehouse,
        isNewMeter: this.dataObj.meterModel.isNewMeter,
      };

      if (this.dataObj.meterModel.isNewMeter) {
        this.dataObj.customMeterModel = this.dataObj.meterModel;
        this.dataObj.meterModel = temp;
      }

      this.hideMeterList();
    },
    applyFilter() {
      this.getMeters();
    },
    getMeters() {
      var criteria = {};

      var filtered = this.filterObj.filter((a) => a.added);
      // console.log("filtered", filtered);

      if (this.isOffline) {
        if (this.offlineMetersLength) {
          let items = this.offlineLookups.meters;
          let isSearch = filtered.some((f) => f.value);
          let isSearchLength = 0;

          if (isSearch) {
            filtered.forEach((filter) => {
              let field = filter.field.toLowerCase();

              if (filter.type == "list") {
                items = items.filter((item) => item[field] == filter.value);
              } else {
                items = items.filter((item) =>
                  item[field].toLowerCase().includes(field)
                );
              }
            });

            isSearchLength = items.length;
          }

          let [start, end] = getOfflinePagingOptions(
            this.options.page,
            this.options.pageSize,
            this.offlineMetersLength
          );

          this.handleMetersResponse({
            items: items.slice(start, end),
            itemsCount: isSearch ? isSearchLength : this.offlineMetersLength,
          });
        } else {
          this.handleMetersResponse({ items: [], itemsCount: 0 });
        }
      } else {
        for (var i = 0; i < filtered.length; i++) {
          if (filtered[i].value != null && filtered[i].value != "")
            criteria[filtered[i].field] = filtered[i].value;
        }

        var parameters = {
          ApplicationId: this.appId,
          ApplicationKey: 0,
          Filters: criteria,
          Options: this.options,
        };

        let loader = this.$loading.show({
          color: "#23348d",
          loader: "dots",
          width: 256,
          height: 256,
          backgroundColor: "#ffffff",
          opacity: 0.5,
        });

        axios
          .post("/SelectMeterActivity/GetMeters", parameters)
          .then((resp) => {
            if (resp.status == 200) {
              this.handleMetersResponse(resp.data);
            } else this.$alertMsg(resp.data.data.text);
          })
          .catch((err) => {
            this.$alertMsg(err.response.data);
            this.$router.push("/login");
          })
          .finally(() => loader.hide());
      }
    },
    handleMetersResponse(resp) {
      if (resp.items.length == 0) {
        this.meters = [];
        this.noDataFound = true;
      } else {
        this.meters = resp.items;
        this.options.total = resp.itemsCount;
        this.totalRow = this.options.total;
      }
      this.$root.$emit("datagrid_updated");
    },
    fillMetersCols() {
      this.metersCols.push({
        dataField: "typeDisplay",
        caption: this.$t("meter.meterType"),
      });
      this.metersCols.push({
        dataField: "reference",
        caption: this.$t("meter.meterNo"),
      });
      this.metersCols.push({
        dataField: "serial",
        caption: this.$t("meter.meterSerialNo"),
      });
      this.metersCols.push({
        dataField: "tagNumber",
        caption: this.$t("meter.meterTagNo"),
      });
      this.metersCols.push({
        dataField: "sizeDisplay",
        caption: this.$t("activities.size"),
      });
      this.metersCols.push({
        dataField: "makeDisplay",
        caption: this.$t("activities.make"),
      });
      this.metersCols.push({
        dataField: "conditionDisplay",
        caption: this.$t("activities.condition"),
      });
      this.metersCols.push({
        dataField: "warehouseDisplay",
        caption: this.$t("activities.warehouse"),
      });
      this.metersCols.push({
        dataField: "comment",
        caption: this.$t("activities.comment"),
      });
    },
    pageChange(pInfo) {
      if (
        this.options.page == pInfo.pageNumber &&
        this.options.pageSize == pInfo.pageSize
      )
        return;

      this.options.page = pInfo.pageNumber;
      this.options.pageSize = pInfo.pageSize;
      this.getMeters();
    },
    onSelectMeter(info) {
      if (info.newRowIndex < 0) return;

      info.rows[info.newRowIndex].data.installationDate =
        this.dataObj.meterModel.installationDate;
      this.selectedMeter = info.rows[info.newRowIndex].data;

      if (this.selectedMeter === null || this.selectedMeter === undefined)
        return;

      this.selectedMeter.gpsX = null;
      this.selectedMeter.gpsY = null;
      this.selectedMeter.gpsAccuracy = null;

      this.getGeoLocation();

      this.dataObj.meterModel.warehouse = this.selectedWarehouse.value;
      this.dataObj.meterModel = this.selectedMeter;
      this.selectWarehouse(this.dataObj.meterModel.warehouse, "meterModel");

      this.fillCustomMeter();
    },
    hideMeterList() {
      this.meters = [];
    },
    completeTask() {
      this.dataObj.meterModel.warehouse = this.selectedWarehouse.value;
      this.dataObj.completeTask();
    },
    getValidationClass(obj1, objName, fieldName) {
      const field = this.$v[obj1][objName][fieldName];

      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty,
        };
      }
    },
    validateAppData() {
      if (
        (!this.dataObj.meterModel.isNewMeter &&
          !this.dataObj.meterModel.gpsX &&
          !this.dataObj.meterModel.gpsY) ||
        (this.dataObj.meterModel.isNewMeter &&
          !this.dataObj.customMeterModel.gpsX &&
          !this.dataObj.customMeterModel.gpsY)
      ) {
        this.$alertMsg(this.$t("common.AwaitingGpsSignal"));
        return false;
      }

      //choose selected meter
      if (this.isNewMeter) {
        this.dataObj.customMeterModel.isMandatorySourceWarehouse =
          this.dataObj.meterModel.isMandatorySourceWarehouse;
        var meter = this.dataObj.customMeterModel;
      } else {
        var meter = this.dataObj.meterModel;
      }

      //validations

      if (meter.type == "" || meter.type == null) {
        this.$alertMsg(this.$t("validation.meterTypeIsRequired"));
        return false;
      }
      if (meter.reference == "" || meter.reference == null) {
        this.$alertMsg(this.$t("validation.meterReferenceIsRequired"));
        return false;
      }
      if (
        !this.dataObj.meterModel.installationDate ||
        !moment(this.dataObj.meterModel.installationDate).isValid() ||
        meter.installationDate == "" ||
        meter.installationDate == null
      ) {
        this.$alertMsg(this.$t("validation.installationDateRequired"));
        return false;
      }
      let today = moment();
      if (
        !this.dataObj.allowFutureInstallationDate &&
        moment(meter.installationDate).isBefore(today) == false
      ) {
        this.$alertMsg(this.$t("validation.instalDateInFutureError"));
        return false;
      }
      if (meter.make == "" || meter.make == null) {
        this.$alertMsg(this.$t("validation.meterMakeIsRequired"));
        return false;
      }
      if (meter.size == "" || meter.size == null) {
        this.$alertMsg(this.$t("validation.meterSizeIsRequired"));
        return false;
      }
      if (meter.condition == "" || meter.condition == null) {
        this.$alertMsg(this.$t("validation.meterConditionIsRequired"));
        return false;
      }
      if (
        this.dataObj.isMandatorySourceWarehouse &&
        (meter.warehouse == "" || meter.warehouse == null)
      ) {
        this.$alertMsg(this.$t("validation.warehouseRequiredToSave"));
        return false;
      }
      if (meter.factor == "" || meter.factor == null) {
        this.$alertMsg(this.$t("validation.readingFactorIsRequired"));
        return false;
      } else if (meter.factor < 1) {
        this.$alertMsg(this.$t("validation.invalidReadingFactor"));
        return false;
      }
      if (meter.dials == "" || meter.dials == null) {
        this.$alertMsg(this.$t("validation.numberOfDielsIsRequired"));
        return false;
      } else if (meter.dials < 4) {
        this.$alertMsg(this.$t("validation.invalidNumberOfDiels"));
        return false;
      }

      //if (meter.serial == '' || meter.serial == null) {
      //  this.$alertMsg(this.$t('validation.meterSerialIsRequired'));
      //  return false;
      //}

      return true;
    },
    fillFiltersObj() {
      this.filterObj.push({
        defaultIndex: 0,
        index: 0,
        field: "Type",
        fieldDesc: this.$t("activities.type"),
        type: "list",
        listSource: this.dataObj.types,
        listValueField: "value",
        listTextField: "text",
        addedDefault: false,
        defaultValue: "-1",
        value: "-1",
        added: false,
      });

      this.filterObj.push({
        defaultIndex: 1,
        index: 2,
        field: "Reference",
        fieldDesc: this.$t("activities.reference"),
        type: "text",
        addedDefault: true,
        defaultValue: "",
        value: "",
        added: true,
      });

      this.filterObj.push({
        defaultIndex: 2,
        index: 2,
        field: "Serial",
        fieldDesc: this.$t("activities.serialNo"),
        type: "text",
        addedDefault: false,
        defaultValue: "",
        value: "",
        added: false,
      });

      this.filterObj.push({
        defaultIndex: 3,
        index: 3,
        field: "TagNumber",
        fieldDesc: this.$t("activities.tagNo"),
        type: "text",
        addedDefault: false,
        defaultValue: "",
        value: "",
        added: false,
      });

      this.filterObj.push({
        defaultIndex: 4,
        index: 4,
        field: "Make",
        fieldDesc: this.$t("activities.make"),
        type: "list",
        listSource: this.dataObj.makes,
        listValueField: "value",
        listTextField: "text",
        addedDefault: false,
        defaultValue: "-1",
        value: "-1",
        added: false,
      });

      this.filterObj.push({
        defaultIndex: 5,
        index: 5,
        field: "Size",
        fieldDesc: this.$t("activities.size"),
        type: "list",
        listSource: this.dataObj.sizes,
        listValueField: "value",
        listTextField: "text",
        addedDefault: false,
        defaultValue: "-1",
        value: "-1",
        added: false,
      });

      this.filterObj.push({
        defaultIndex: 6,
        index: 6,
        field: "Condition",
        fieldDesc: this.$t("activities.condition"),
        type: "list",
        listSource: this.dataObj.conditions,
        listValueField: "value",
        listTextField: "text",
        addedDefault: false,
        defaultValue: "-1",
        value: "-1",
        added: false,
      });

      this.filterObj.push({
        defaultIndex: 7,
        index: 7,
        field: "Warehouse",
        fieldDesc: this.$t("activities.warehouse"),
        type: "list",
        listSource: this.dataObj.warehouses,
        listValueField: "value",
        listTextField: "text",
        addedDefault: false,
        defaultValue: "-1",
        value: "-1",
        added: false,
      });
    },
    getMandatoryFieldClass(field) {
      if (field == null || field == "") return "input mandatory--field ";
      else return "input";
    },
    async getGeoLocation() {
      await navigator.geolocation.getCurrentPosition((position) => {
        this.dataObj.meterModel.gpsX = position.coords.longitude;
        this.dataObj.meterModel.gpsY = position.coords.latitude;
        this.dataObj.meterModel.gpsAccuracy =
          position.coords.accuracy.toFixed(1);

        this.dataObj.customMeterModel.gpsX = position.coords.longitude;
        this.dataObj.customMeterModel.gpsY = position.coords.latitude;
        this.dataObj.customMeterModel.gpsAccuracy =
          position.coords.accuracy.toFixed(1);

        //this.previewMeterLocation();
      });
    },
    previewMeterLocation() {
      if (this.isNewMeter) {
        this.meterLocation = {
          lat: parseFloat(this.dataObj.customMeterModel.gpsY),
          lng: parseFloat(this.dataObj.customMeterModel.gpsX),
        };
      } else {
        this.meterLocation = {
          lat: parseFloat(this.dataObj.meterModel.gpsY),
          lng: parseFloat(this.dataObj.meterModel.gpsX),
        };
      }

      this.showMapDialog = true;
    },
    gMapDragEnd(evnt) {
      this.dataObj.meterModel.gpsX = evnt.lng();
      this.dataObj.meterModel.gpsY = evnt.lat();

      this.dataObj.customMeterModel.gpsX = evnt.lng();
      this.dataObj.customMeterModel.gpsY = evnt.lat();
    },
  },
};
